const appContent = {
  appTitle: 'Store Manager',
  required: 'Fields mark with star * are mandatory.',
};
export default {
  appContent,
};
